import React, { useEffect, useMemo, useState } from "react";
import { ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, UploadFileStatus } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { isMobileView } from "../../stack/utils";
import { Image } from "../../image/Image";
import { Divider } from "../../divider/Divider";
import TextField from "../TextField";
import { Button } from "../../button/Button";
import { Space } from "../../space/Space";
import { UploadFile } from "../../UploadFile/UploadFile";
import { RegexConfig } from "../constants";
const isFromMobileView = isMobileView();
// @ts-ignore
const CollateralDownloadInfoCard = ({ previewUrl, triggerAction, height, goBackAction, previewAction, partnerData, downloadAction, uploadImageToS3, previewLoading, downloadLoading, fileName, uploadingImagetoS3, uploadedImagetoS3, callSamePropAgain, buildType, collateralCategory }) => {
    const [fullName, setFullName] = useState("");
    const [emailId, setEmailId] = useState("");
    const [whatsAppNumber, setWhatsAppNumber] = useState("");
    const [photoError, setPhotoError] = useState(false);
    const [fileLimitExceeded, setFileLimitExceeded] = useState(false);
    const [imageUrl, setImageUrl] = useState(undefined);
    const [editPhoto, setEditPhoto] = useState(false);
    const [isPhotoRemoved, setPhotoRemoved] = useState(false);
    const [fileUrl, setFileUrl] = useState("");
    const [imageFromAPI, setImageFromAPI] = useState("");
    const [imageUrlFromSource, setImageUrlFromSource] = useState("");
    const [isNameEmpty, setNameEmpty] = useState(false);
    const [isEmailEmpty, setEmailEmpty] = useState(false);
    const [whatsAppNumberEmpty, setWhatsAppNumberEmpty] = useState(false);
    const [isValidEmail, setValidEmail] = useState(false);
    const [improperFileFormat, setImproperFileFormat] = useState(false);
    const [callSimilarCallback, setCallSimilarCallback] = useState(0);
    const [uploadedText, setUploadedText] = useState(true);
    const [enableCTA, setEnableCTA] = useState(false);
    const prefixUrl = buildType === "PARTNER_PRODUCTION" ? "https://volt-partner-logos-prod.s3.ap-south-1.amazonaws.com/"
        : "https://volt-partner-logos-alpha.s3.ap-south-1.amazonaws.com/";
    const emailRegex = new RegExp(RegexConfig.NEW_EMAIL);
    useEffect(() => {
        // @ts-ignore
        setFullName(partnerData?.partnerName);
        // @ts-ignore
        setEmailId(partnerData?.accountHolderEmail);
        // @ts-ignore
        setWhatsAppNumber(partnerData?.accountHolderPhoneNumber.slice(3));
        // @ts-ignore
        setImageFromAPI(partnerData?.partnerLogoImgSrc);
    }, [partnerData]);
    useEffect(() => {
        if (uploadedImagetoS3) {
            setTimeout(() => {
                setUploadedText(false);
            }, 3000);
            setEnableCTA(true);
        }
    }, [uploadedImagetoS3, callSamePropAgain]);
    useEffect(() => {
        if (uploadingImagetoS3) {
            setUploadedText(true);
            setEnableCTA(false);
        }
    }, [uploadingImagetoS3, callSamePropAgain]);
    useEffect(() => {
        if (imageUrl !== undefined) {
            if (imageUrl.size > 5 * 1024 * 1024) {
                setFileLimitExceeded(true);
            }
            else if (imageUrl.type && !imageUrl.type.startsWith('image/')) {
                setImproperFileFormat(true);
            }
            else {
                setPhotoError(false);
                setFileLimitExceeded(false);
                setImproperFileFormat(false);
                triggerAction({
                    ...uploadImageToS3,
                    payload: {
                        imageBody: imageUrl
                    }
                });
            }
        }
    }, [imageUrl, callSimilarCallback]);
    useEffect(() => {
        if (imageFromAPI) {
            setImageUrlFromSource(`${prefixUrl}${imageFromAPI}`);
            setPhotoError(false);
            setFileLimitExceeded(false);
            setImproperFileFormat(false);
            setEnableCTA(true);
        }
    }, [imageFromAPI]);
    useEffect(() => {
        if (isPhotoRemoved) {
            setFileLimitExceeded(false);
            setPhotoError(false);
            setImproperFileFormat(false);
            setCallSimilarCallback(Math.random);
        }
    }, [isPhotoRemoved]);
    useEffect(() => {
        if (editPhoto) {
            setEditPhoto(false);
        }
    }, [editPhoto]);
    const headerView = () => {
        return (React.createElement(View, { style: styles.headerViewContainer },
            React.createElement(Typography, { label: "Create co-branded collateral", fontSize: FontSizeTokens.LG, fontWeight: "700", lineHeight: 26, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(TouchableOpacity, { onPress: () => {
                    triggerAction({
                        ...goBackAction
                    });
                } },
                React.createElement(Icon, { name: IconTokens.CrossIcon, size: IconSizeTokens.XXL }))));
    };
    const previewPressAction = () => {
        if ((imageUrl !== undefined || imageUrlFromSource) && !fileLimitExceeded && !improperFileFormat && fullName !== '' && emailId !== '' && emailRegex.test(emailId) && whatsAppNumber !== '' && whatsAppNumber.length <= 35 && fullName.length <= 35) {
            triggerAction({
                ...previewAction,
                payload: {
                    fullName: fullName,
                    phoneNumber: whatsAppNumber,
                    emailId: emailId,
                    collateralImageFileName: fileName,
                    //@ts-ignore
                    partnerAccountId: partnerData?.accountId,
                    collateralCategory: collateralCategory,
                    ...previewAction.payload
                }
            });
        }
        else {
            if (fullName === '' || fullName.length > 35) {
                setNameEmpty(true);
            }
            if (emailId === '') {
                setEmailEmpty(true);
            }
            if (whatsAppNumber === '' || whatsAppNumber.length > 35) {
                setWhatsAppNumberEmpty(true);
            }
            if (!emailRegex.test(emailId)) {
                setValidEmail(true);
            }
            if (imageUrl === undefined && !imageUrlFromSource) {
                setPhotoError(true);
            }
        }
    };
    const downloadPressAction = () => {
        if ((imageUrl !== undefined || imageUrlFromSource) && !fileLimitExceeded && !improperFileFormat && fullName !== '' && emailId !== '' && emailRegex.test(emailId) && whatsAppNumber !== '' && whatsAppNumber.length <= 35 && fullName.length <= 35) {
            triggerAction({
                ...downloadAction,
                payload: {
                    fullName: fullName,
                    phoneNumber: whatsAppNumber,
                    emailId: emailId,
                    collateralImageFileName: fileName,
                    //@ts-ignore
                    partnerAccountId: partnerData?.accountId,
                    userImage: imageUrl,
                    actionLogo: imageUrl,
                    collateralCategory: collateralCategory,
                    ...downloadAction.payload
                }
            });
        }
        else {
            if (fullName === '' || fullName.length > 35) {
                setNameEmpty(true);
            }
            if (emailId === '') {
                setEmailEmpty(true);
            }
            if (whatsAppNumber === '' || whatsAppNumber.length > 35) {
                setWhatsAppNumberEmpty(true);
            }
            if (!emailRegex.test(emailId)) {
                setValidEmail(true);
            }
            if (imageUrl === undefined && !imageUrlFromSource) {
                setPhotoError(true);
            }
        }
    };
    useEffect(() => {
        if (fullName !== '' && fullName.length <= 35) {
            setNameEmpty(false);
        }
        if (emailId !== '') {
            setEmailEmpty(false);
            setValidEmail(false);
        }
        if (whatsAppNumber !== '' && whatsAppNumber.length <= 35) {
            setWhatsAppNumberEmpty(false);
        }
        if (emailRegex.test(emailId)) {
            setValidEmail(false);
        }
    }, [fullName, emailId, whatsAppNumber]);
    const uploadFile = useMemo(() => {
        return (React.createElement(UploadFile, { status: UploadFileStatus.DEFAULT, onDeleteFile: () => {
                setImageUrl(undefined);
            }, setUploadFileURL: (fileUrl, uploadDetails) => {
                setFileUrl(fileUrl);
                setImageUrl(uploadDetails);
                setPhotoRemoved(false);
                setImproperFileFormat(false);
                setCallSimilarCallback(Math.random());
            }, errorMessage: 'Supported file format of max. size 2 MB - jpeg, pdf, png', message: 'Supported file format of max. size 2 MB - jpeg, pdf, png', isFromAddLogo: true, isEditClicked: editPhoto, isPhotoRemoved: isPhotoRemoved, imageUrlFromSource: imageUrlFromSource, fileFormatIncorrect: improperFileFormat, callSimilarCallback: callSimilarCallback }));
    }, [imageUrlFromSource, editPhoto, isPhotoRemoved, fileUrl, imageUrl, callSimilarCallback, improperFileFormat]);
    const onPressRemove = () => {
        setImageUrl(undefined);
        setPhotoRemoved(true);
        setImageUrlFromSource(undefined);
        setImageFromAPI(undefined);
    };
    const uploadingImageView = useMemo(() => {
        return ((uploadingImagetoS3 || uploadedImagetoS3) && uploadedText) &&
            (React.createElement(View, { style: styles.marginTop4 },
                React.createElement(Typography, { label: uploadingImagetoS3 ? "Uploading..." : "Uploaded successfully", fontWeight: "500", numberOfLines: 1, fontSize: FontSizeTokens.XS, lineHeight: 18, fontFamily: FontFamilyTokens.Inter, color: uploadedImagetoS3 ? ColorTokens.System_Happy : ColorTokens.Primary_100 })));
    }, [uploadingImagetoS3, uploadedImagetoS3, uploadedText]);
    const ctaView = useMemo(() => {
        return (React.createElement(View, { style: styles.downloadFormBottomContainer },
            React.createElement(TouchableOpacity, { style: styles.button, activeOpacity: 1 },
                React.createElement(Button, { label: "Preview", type: enableCTA ? ButtonTypeTokens.LargeSoftFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                        previewPressAction();
                    }, loading: previewLoading })),
            React.createElement(TouchableOpacity, { style: styles.downloadButton, activeOpacity: 1 },
                React.createElement(Button, { label: "Download", type: enableCTA ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                        downloadPressAction();
                    }, loading: downloadLoading }))));
    }, [enableCTA, fullName, emailId, whatsAppNumber, imageUrlFromSource, imageUrl, emailRegex, fileLimitExceeded, improperFileFormat]);
    const downloadForm = () => {
        return (React.createElement(View, { style: { flex: 1 } },
            React.createElement(View, { style: styles.downloadFormContainer },
                React.createElement(Typography, { label: "Add collateral details", fontFamily: FontFamilyTokens.Poppins, fontWeight: "600", fontSize: FontSizeTokens.LG, lineHeight: 26, color: ColorTokens.Grey_Night }),
                uploadFile,
                ((imageUrl || imageUrlFromSource || imageFromAPI) && !improperFileFormat) &&
                    React.createElement(View, { style: styles.editRemovePhotoContainer },
                        React.createElement(TouchableOpacity, { style: styles.editPhotoContainer, onPress: () => {
                                setEditPhoto(true);
                            } },
                            React.createElement(Icon, { name: IconTokens.EditBlue, size: IconSizeTokens.MD }),
                            React.createElement(Space, { size: SizeTypeTokens.XS }),
                            React.createElement(Typography, { label: "Edit", fontFamily: FontFamilyTokens.Inter, fontWeight: "600", fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Primary_100 })),
                        React.createElement(TouchableOpacity, { style: styles.editPhotoContainer, onPress: () => {
                                onPressRemove();
                            } },
                            React.createElement(Icon, { name: IconTokens.Delete, size: IconSizeTokens.MD }),
                            React.createElement(Space, { size: SizeTypeTokens.XS }),
                            React.createElement(Typography, { label: "Remove", fontFamily: FontFamilyTokens.Inter, fontWeight: "600", fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Primary_100 }))),
                React.createElement(View, { style: styles.marginTop8 }, isFromMobileView ?
                    React.createElement(Typography, { label: "The maximum size is 5MB & acceptable formats\nis JPEG, PNG or JPG", fontWeight: "400", numberOfLines: 2, fontSize: FontSizeTokens.XS, lineHeight: 18, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal })
                    :
                        React.createElement(Typography, { label: "The maximum size is 5MB & acceptable formats is JPEG, PNG or JPG", fontWeight: "400", numberOfLines: 1, fontSize: FontSizeTokens.XS, lineHeight: 18, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal })),
                uploadingImageView,
                (photoError || fileLimitExceeded || improperFileFormat) &&
                    React.createElement(View, { style: styles.marginTop4 },
                        React.createElement(Typography, { label: fileLimitExceeded ? "File size has exceeded limit" : improperFileFormat ? "Allowed file format are PNG, JPEG and JPG" : "Logo is required to download or preview collateral.", fontWeight: "500", numberOfLines: 1, fontSize: FontSizeTokens.XS, lineHeight: 18, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.System_Error })),
                React.createElement(View, { style: styles.marginTop24 },
                    React.createElement(TextField, { label: "Full name", holder: fullName ? fullName : 'Full name', value: fullName, autoFocus: false, showError: isNameEmpty, errorText: (fullName !== '' && fullName.length > 35) ? 'Max length allowed is 35 characters' : 'Please enter name', onChangeText: (text) => {
                            setFullName(text);
                            setNameEmpty(false);
                        } })),
                React.createElement(View, { style: styles.marginTop24 },
                    React.createElement(TextField, { label: "Email id", holder: emailId ? emailId : 'Email id', value: emailId, showError: isEmailEmpty || isValidEmail, errorText: (emailId !== '' && isValidEmail) ? 'Please enter valid email id' : 'Please enter email id', autoFocus: false, onChangeText: (text) => {
                            setEmailId(text);
                            setEmailEmpty(false);
                        } })),
                React.createElement(View, { style: styles.marginTop24 },
                    React.createElement(TextField, { label: "WhatsApp Number", holder: whatsAppNumber ? whatsAppNumber : 'WhatsApp Number', value: whatsAppNumber, showError: whatsAppNumberEmpty, errorText: (whatsAppNumber !== '' && whatsAppNumber.length > 35) ? 'Max length allowed is 35 characters' : 'Please enter contact number', autoFocus: false, onChangeText: (text) => {
                            setWhatsAppNumber(text);
                            setWhatsAppNumberEmpty(false);
                        } }))),
            !isFromMobileView &&
                React.createElement(View, { style: styles.downloadFormBottomMainContainer }, ctaView)));
    };
    const imagePreview = useMemo(() => {
        return (React.createElement(View, { style: styles.imagePreviewContainer },
            React.createElement(View, { style: {
                    borderWidth: 2,
                    borderColor: '#E4E7EC',
                    borderRadius: 2,
                    width: isFromMobileView ? 330 : 488,
                    height: isFromMobileView ? 330 : 488,
                } },
                React.createElement(Image, { size: ImageSizeTokens.FULL, uri: previewUrl, padding: SizeTypeTokens.NONE }))));
    }, [previewUrl]);
    const ctaMobileView = useMemo(() => {
        return (React.createElement(View, { style: styles.downloadMobileFormBottomContainer },
            React.createElement(TouchableOpacity, { style: styles.button, activeOpacity: 1 },
                React.createElement(Button, { label: "Preview", type: enableCTA ? ButtonTypeTokens.LargeSoftFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                        previewPressAction();
                    }, loading: previewLoading })),
            React.createElement(TouchableOpacity, { style: styles.downloadButton, activeOpacity: 0.7 },
                React.createElement(Button, { label: "Download", type: enableCTA ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                        downloadPressAction();
                    }, loading: downloadLoading }))));
    }, [enableCTA, fullName, emailId, whatsAppNumber, imageUrlFromSource, imageUrl, emailRegex, fileLimitExceeded, improperFileFormat]);
    return (React.createElement(View, { style: [styles.container, { height: height }] },
        headerView(),
        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
        isFromMobileView ?
            React.createElement(View, { style: { flex: 1 } },
                React.createElement(ScrollView, { style: styles.columnContainer },
                    imagePreview,
                    downloadForm()),
                ctaMobileView)
            : React.createElement(View, { style: styles.rowContainer },
                imagePreview,
                downloadForm())));
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        height: "100%",
    },
    headerViewContainer: {
        height: 60,
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 16
    },
    imagePreviewContainer: {
        width: isFromMobileView ? '100%' : 534,
        backgroundColor: '#F3F5FC',
        padding: isFromMobileView ? 16 : 24,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center'
    },
    downloadFormContainer: {
        paddingTop: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingBottom: 16,
        flexDirection: 'column',
        width: isFromMobileView ? '100%' : 490
    },
    rowContainer: {
        flexDirection: 'row',
        flex: 1,
    },
    columnContainer: {
        flexDirection: 'column',
        flex: 1,
        paddingBottom: 80
    },
    addPhotoContainer: {
        marginTop: 16,
        paddingHorizontal: 18,
        paddingVertical: 24,
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        width: 96,
        height: 96,
        borderRadius: 4,
        borderStyle: 'dashed',
        borderWidth: 1,
        borderColor: '#98A2B3'
    },
    marginTop2: {
        marginTop: 2
    },
    marginTop4: {
        marginTop: 4
    },
    marginTop8: {
        marginTop: 8
    },
    marginTop24: {
        marginTop: 24
    },
    marginTop16: {
        marginTop: 16
    },
    downloadFormBottomContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 12,
        paddingHorizontal: 24,
    },
    downloadMobileFormBottomContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        paddingVertical: 12,
        width: '100%',
        marginTop: 16,
        height: 64,
        borderTopWidth: 1,
        borderColor: '#F2F4F7',
        marginLeft: 4,
        paddingHorizontal: 12,
        backgroundColor: 'white',
        position: 'absolute',
        bottom: 0
    },
    downloadFormBottomMainContainer: {
        width: '100%',
        position: 'absolute',
        bottom: 0,
        height: 64,
        borderTopWidth: 1,
        borderColor: '#F2F4F7',
    },
    button: {
        flex: 0.5,
    },
    downloadButton: {
        flex: 0.5,
        marginLeft: 12,
    },
    editRemovePhotoContainer: {
        marginTop: 8,
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: 138
    },
    editPhotoContainer: {
        flexDirection: 'row',
        alignContent: 'center',
        alignSelf: 'center',
        alignItems: 'center'
    }
});
// @ts-ignore
export default (CollateralDownloadInfoCard);
